import * as THREE from 'three';

import type { PreparedFeature } from './feature-preparation.js';
import type { OverlayGeometryBatch } from './overlay-geometry-batch.js';
import type { FeatureOverlay, FeaturePart } from '../../types/terrain-types.js';

export const FEATURE_COLOR = 0x00ecd1;

/** Attach worker-produced buffers, yielding between parts of large Multi* features. */
export function* buildFeatureOverlay(
  prepared: PreparedFeature,
  batch: OverlayGeometryBatch,
): Generator<void, FeatureOverlay> {
  const parts: FeaturePart[] = [];
  for (const part of prepared.parts) {
    parts.push({
      positions: part.positions,
      count: part.positions.length / 3,
      worldXY: part.worldXY,
      resolvedZoom: part.resolvedZoom,
      commit: batch.add(prepared.guid, part.kind, part.positions, part.indices, part.center),
    });
    yield;
  }
  return { ...prepared, parts, group: new THREE.Group() };
}
